export default __webpack_public_path__ + "static/media/SeedPlants.23e55027.jpg";